module.exports = __webpack_public_path__ + "img/png.6e5ab2a8.png";